import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState, useMemo } from 'react';

import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleHeroQuoteAndImage = ({
    attribution,
    image,
    statement,
}) => {

    const containerRef = useRef();
    const imageRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                    entry.target.classList.add('lazy-image-show');
                } else {
                    entry.target.classList.remove('lazy-image-show');
                }
            });
        }, { rootMargin: '50px' });

        const imageElement = imageRef.current;
        observer.observe(imageElement);

        return () => {
            observer.disconnect();
        };
    }, [imageRef]);

    return (
        <div
            className='layout-container-padding-right flex flex-wrap max-w-container py-70 sm:py-150 overflow-hidden'
            ref={containerRef}>
            {/* Sidebar spacing */}
            <div className='w-sidebar'>

            </div>
            {/* Body */}
            <div className='flex-1 layout-negative-margin sm:my-30 md:my-75 relative'>
                <section className='layout-item-padding'>
                    <blockquote className='phoenix_court-border background-4px type-style-5 pl-35 md:pl-90 sm:w-10/12'>
                        <div
                            className='rich-text quote type-style-3 md:type-style-2'
                            dangerouslySetInnerHTML={{__html: statement }}/>
                        {attribution &&
                            <p className='type-style-8 pt-10 pb-15'>
                                {attribution}
                            </p>
                        }
                    </blockquote>

                    {/* Image */}
                    {image &&
                        <div
                            className='lazy-image-hidden absolute w-full sm:w-6/12 md:w-4/12 sm:right-0 sm:px-10 md:px-18 md:mr-w-1/12'
                            ref={imageRef}>
                            <Image
                                containerClassName='rounded-lg'
                                {...image} />
                        </div>
                    }
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    attribution: PropTypes.string,
    image: PropTypes.object,
    statement: PropTypes.string.isRequired,
};


ModuleHeroQuoteAndImage.propTypes = propTypes;

export default ModuleHeroQuoteAndImage;
